import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import loginPool from '../../aws-pool/login-pool';
import { encryptData, scrollTo } from '../../common';
import { APP_FLOW } from '../../common/constant';
import { MOSQUE_BG } from '../../common/images-s3';
import { getAppFlow } from '../utils/app.utils';
import * as userAction from '../../redux/actions/userAction';
import * as zakatCalc from '../../redux/actions/zakatCalcAction';
import * as zakat from '../../redux/actions/zakatActions';
import { useDispatch, useSelector } from 'react-redux';
import { fidyahActions } from '../../redux/reducers/fidyah-slice';

const ImageLoader = lazy(() => import('../../common/image-loader'));

const SessionExpire = ({ t }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const flowType = getAppFlow();
  const userData = useSelector(state => state.userReducer);

  const onClickRedirect = () => {
    window.location.href = window.location.href
  };

  useEffect(() => {
      // Clear storage
      localStorage.clear();
      sessionStorage.clear();
      dispatch(zakatCalc.resetZakatCalcData());
      dispatch(zakat.resetZakatData());
      dispatch(userAction.resetUserDataExceptURL());
      dispatch(fidyahActions.reset());
      scrollTo();
  }, []);

  return (
    <div className="page-error">
      <div className="error-body session">
        <div className="mask"></div>
        {/* <Suspense fallback={null}>
          <ImageLoader type="image" src={MOSQUE_BG}></ImageLoader>
        </Suspense> */}
        <div className="c-error">
          <h3>{t('Session_timeout_title')}</h3>
          <p dangerouslySetInnerHTML={{ __html: t('Session_timeout_subtitle') }}></p>
          <button
            type="button"
            className="btn btn-light"
            onClick={onClickRedirect}
          >
            {t('Refresh')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default withTranslation()(SessionExpire);